/** @jsx h */
/* eslint-disable react/jsx-no-bind */
import { labels } from '../config';
import TeaserGeneral from './Results/TeaserGeneral';
import Pagination from './Results/Pagination';
import { Fragment } from 'preact';

const ResultContainer = ({
  searchType,
  facetsActive,
  allResultCount,
  list,
  pagination,
  loadMore,
  pluginNamespace,
  isMainSearch,
  showPrio,
}) => {
  const currentPlz = (function () {
    let plz = null;

    if (facetsActive) {
      facetsActive.forEach(function (facet) {
        if (facet.name === 'networkZipCodes') {
          plz = facet.item;
        }
      });
    }

    return plz;
  })();

  return (
    <Fragment>
      <h2 className="sr-only">{labels.results.heading}</h2>
      <div
        className="search__result-state"
        aria-live="polite"
        aria-atomic="true"
      >
        <p>
          <strong>
            {allResultCount === 1 ? (
              labels.results.foundSingular
            ) : (
              <Fragment>
                {labels.results.found &&
                  labels.results.found.replace('@resultsTotal', allResultCount)}
              </Fragment>
            )}
          </strong>
        </p>
      </div>
      {list.length ? (
        <ul className="list-teaser">
          {list.map((result, index) => {
            return (
              <TeaserGeneral
                key={index}
                result={result}
                isMainSearch={isMainSearch}
                showPrio={showPrio}
                currentPlz={currentPlz}
              />
            );
          })}
        </ul>
      ) : (
        <p>{labels.search.unavailable}</p>
      )}
      <Pagination
        pagination={pagination}
        loadMore={loadMore}
        pluginNamespace={pluginNamespace}
      />
    </Fragment>
  );
};

export default ResultContainer;
